enum ApplicationReviewDecisionValue {
  RequestInformation = 'RequestInformation',
  Approve = 'Approve',
  Reject = 'Reject',
}
export default ApplicationReviewDecisionValue;
